module.exports = __webpack_public_path__ + "assets/img/edit.82ad92eb.svg";